import { Row } from "antd";
import styled from "styled-components";

export const CalendarLayout = styled(Row)`
  height: 700px;
  background-image: ${({ image }) => ` url(${image})`};
  background-size: 100% 100%;
  background-position: 100% 0%;
  background-repeat: no-repeat;
  @media (max-width: 1000px) {
    height: 1000px;
  }
  @media (max-width: 700px) {
    height: 1020px;
  }
  @media (max-width: 650px) {
    height: 950px;
  }
`;
